<template>
  <div v-if="bpmIncompleteMessage" class="bpm-incomplete-warning">
    <div>
      {{ bpmIncompleteMessage }}
    </div>
  </div>
</template>

<script>
import { brandIsBwg } from '@/helpers/BrandHelper'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      configuration: 'configuration/configuration',
    }),
    bpmIncompleteMessage() {
      if (!this.configuration?.EmissionAndConsumption) return null
      if (!brandIsBwg()) return null

      if (this.configuration.AdmissionIncomplete && !this.configuration.CO2Forfait)
        return this.i18n.t('/Emission And Consumption/NoForfaitIncomplete')
      if (!this.configuration.AdmissionIncomplete && this.configuration.CO2Forfait)
        return this.i18n.t('/Emission And Consumption/ForfaitComplete')
      if (this.configuration.AdmissionIncomplete && this.configuration.CO2Forfait)
        return this.i18n.t('/Emission And Consumption/ForfaitIncomplete')
      return null
    },
  },
}
</script>
<style lang="scss" scoped>
.bpm-incomplete-warning {
  div {
    background-color: #f1f4f5;
    padding: 0.5rem;
  }

  padding-bottom: 0.5rem;
}
</style>
